import React from 'react';
import {
  Typography,
  Stack,
} from '@mui/material';
import { PipelinePreviewCard } from './PipelinePreviewCard';

interface PipelinesListProps {
  pipelines: any[];
  onOpenStream?: (streamUuid: string) => void;
}

export const PipelinesList: React.FC<PipelinesListProps> = ({
  pipelines,
  onOpenStream,
}) => {
  return (
    <Stack spacing={1}>
      {pipelines.map((pp: any) => (
        <PipelinePreviewCard key={pp.key || pp.uuid} pipeline={pp} onOpenStream={onOpenStream} />
      ))}
      {pipelines.length === 0 && (
        <Typography variant="body2" color="text.secondary">Not in any pipeline</Typography>
      )}
    </Stack>
  );
};


